export enum FeatureColorProperty {
  Blue = '#414EAC',
  SoftRed = '#FF7373',
  Red = '#FF0000',
  Cyan = '#2FA7A7',
  Orange = '#D18410',
  Green = '#00FF00',
}
